export default (axios, checkHeaders) => ({
  getList (data = {}) {
    return axios.get('/notes', { params: data.filters || {} })
  },
  postOne (data = {}) {
    return axios.post('/note', data.body, { params: data.filters || {} })
  },
  getOne (data = {}) {
    return axios.get('/note/' + data.id, { params: data.filters || {} })
  },
  patchOne (data = {}) {
    return axios.patch('/note/' + data.id, data.body, { params: data.filters || {} })
  },
  deleteOne (data = {}) {
    return axios.delete('/note/' + data.id, { params: data.filters || {} })
  }
})
